import { Component } from '@angular/core';

@Component({
  selector: 'app-skeleton-card-vehicle',
  templateUrl: './skeleton-card-vehicle.component.html',
  styleUrls: ['./skeleton-card-vehicle.component.scss'],
})
export class SkeletonCardVehicleComponent {}
